import { useEffect, useRef } from 'react';
import { useEffectCallback } from '../useEffectCallback';
/*
 * This simple hook is used to listen for a click away on a DOM element
 * just pass the ref returned from the hook into the component you want
 * to listen for the click away event, and pass the callback to run when
 * the click away is triggered.
 */
export function useClickAway(onClickAway: (event: any) => void) {
  const ref = useRef<any>(null);
  const safeOnClickAway = useEffectCallback(onClickAway);

  useEffect(() => {
    const handleClickAway = (event: any) => {
      // Check if the click way outside the target.
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      safeOnClickAway(event);
    };

    document.addEventListener('mousedown', handleClickAway);
    document.addEventListener('touchstart', handleClickAway);

    return () => {
      document.removeEventListener('mousedown', handleClickAway);
      document.removeEventListener('touchstart', handleClickAway);
    };
  }, [ref, safeOnClickAway]);

  return ref;
}
